import React, { startTransition, useEffect, useState } from "react";
// import AdminNavigation from "./AdminNavigation";
import { Button, Col } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { getHospitalData } from "../../api/Hospital";
import { userApproveOrDeny } from "../../api/User";
import moment from "moment-timezone";
import { changePasswordUrl } from "../../config/app-config";
import { Empty, Input, Pagination, Radio } from "antd";
import { Icon } from "@iconify/react/dist/iconify.js";
import Loader from "../../customJS/Loader";
import { getDoctorsList } from "../../api/Doctor";
import { getResourceThumbnail } from "../../customJS/custom";
// import { ApproveHospitalData, getHospitalData } from "../../api/hospital";

const NewRequest = () => {
  const [hospitals, setHospitals] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [paginationCount, setPaginationCount] = useState(0);
  const [request, setRequest] = useState("hospital");

  useEffect(() => {
    let timer = setTimeout(() => {
      startTransition(() => {
        if (request === "hospital") {
          getRequestedHospitals();
        } else if (request === "doctor") {
          getRequestedDoctors();
        }
      });
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [currentPage, search, request]);

  function getRequestedHospitals() {
    setLoader(true);

    getHospitalData({ flag: "N", search, pageNo: currentPage })
      .then((response) => {
        setLoader(false);
        if (response.data.status === 1) {
          const data = response.data.data;
          startTransition(() => {
            setHospitals(data);
            setPaginationCount(data.totalCount);
          });
        }
      })
      .catch((error) => {
        console.error(error.message);
      });
  }

  function getRequestedDoctors() {
    setLoader(true);

    let obj = {
      hospitalId: 0,
      pageNo: currentPage,
      flag: "R",
      state: "requestApprove",
      search: search,
    };
    setLoader(true);
    getDoctorsList(obj)
      .then((response) => {
        if (response.data.status === 1) {
          // console.log(response.data.data);
          setDoctors(response.data.data.doctorsLists);
          // console.log("response:::", response);
          setPaginationCount(response.data.data.totalCount);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  }

  const handleClick = (e, flag) => {
    var data = {
      id: e,
      flag: flag,
      url: changePasswordUrl,
      state: request,
    };

    // console.log("id", e, "flag", flag);
    userApproveOrDeny(data)
      .then(() => {
        if (request === "hospital") {
          getRequestedHospitals();
        } else if (request === "doctor") {
          getRequestedDoctors();
        }
      })
      .catch(() => {
        console.log("Error");
      });
  };

  const onSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(0);
  };

  const onPageChange = (newCurrent) => {
    setCurrentPage(newCurrent - 1);
  };

  const changeRequest = (newRequest) => {
    setRequest(newRequest);
    setCurrentPage(0);
    setSearch("");
  };

  return (
    <div>
      {loader && <Loader />}
      <Col xl={3} className="px-5 pt-4">
        <Input
          size="large"
          className="hospital-search"
          placeholder="Providers..."
          value={search}
          suffix={
            <Icon
              icon="material-symbols:search-rounded"
              width="24"
              height="24"
              style={{ color: "#2607e5" }}
            />
          }
          onChange={(e) => onSearch(e)}
        />
      </Col>

      <Col xs="12">
        <hr className="hr" />
      </Col>
      <Col xs="12 px-5 pt-2">
        <Radio.Group
          value={request}
          onChange={(e) => changeRequest(e.target.value)}
        >
          <Radio.Button value="hospital">
            <Icon icon="vaadin:hospital" width="21" height="21" /> Provider(s)
          </Radio.Button>
          <Radio.Button value="doctor">
            <Icon icon="fontisto:doctor" width="21" height="24" /> Provider(s)
          </Radio.Button>
        </Radio.Group>
      </Col>

      <Col xs="12 p-5 table-width table-responsive">
        {request === "hospital" && hospitals?.hospitalList?.length > 0 ? (
          <Table className="unitedTable" size="sm" hover>
            <thead>
              <tr>
                <th>Provider Name</th>
                <th>Location</th>
                <th>Zip</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Request Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {hospitals?.hospitalList?.map((row, index) => (
                <tr key={index}>
                  <td>{row.hospitalName}</td>
                  <td>{row.hospitalAddress}</td>
                  <td>{row.zipCode}</td>
                  <td>{row.mailId}</td>
                  <td>{row.phoneNo}</td>
                  {/* <td>{row.totalDoctors}</td> */}
                  <td>
                    {moment(row.createdDate, "YYYY-MM-DD HH:mm").format(
                      "DD/MM/YYYY"
                    )}
                  </td>
                  <td>
                    <div className="d-flex gap-2">
                      <Button
                        className="uniteButton"
                        onClick={() => handleClick(row.userId, "A")}
                      >
                        Approve
                      </Button>
                      <Button
                        className="uniteButton-outline"
                        onClick={() => handleClick(row.userId, "D")}
                      >
                        Deny
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : request === "doctor" && doctors?.length > 0 ? (
          <Table className="unitedTable" size="sm" hover>
            <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Speciality</th>
                <th style={{ width: "20rem" }}>Provider</th>
                <th>Email</th>
                <th>Phone</th>
                <th style={{ width: "8rem" }}>Request Date</th>
                <th style={{ width: "2rem" }}></th>
              </tr>
            </thead>
            <tbody>
              {doctors?.map((doctor, index) => (
                <tr key={index}>
                  <td align="center">
                    {doctor.image ? (
                      getResourceThumbnail(doctor.image)
                    ) : (
                      <Icon
                        icon={
                          doctor.gender === "FEMALE"
                            ? "et:profile-female"
                            : "et:profile-male"
                        }
                        width="30"
                        height="30"
                        style={{ color: "#0D224E" }}
                      />
                    )}
                  </td>
                  <td>{doctor.displayName}</td>
                  <td>{doctor.specialityName}</td>
                  <td>{doctor.hospitalName}</td>
                  <td>{doctor.mailId || "Not Available"}</td>
                  <td>{doctor.phoneNo || "Not Available"}</td>
                  <td>
                    {moment(doctor.createdDate, "YYYY-MM-DD HH:mm").format(
                      "MMMM D, YYYY"
                    )}
                  </td>
                  <td>
                    <div className="d-flex gap-2">
                      <Button
                        className="uniteButton"
                        onClick={() => handleClick(doctor.userId, "A")}
                      >
                        Approve
                      </Button>
                      <Button
                        className="uniteButton-outline"
                        onClick={() => handleClick(doctor.userId, "D")}
                      >
                        Deny
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <Empty />
        )}
      </Col>
      {paginationCount > 12 && (
        <Pagination
          pageSize={12}
          current={currentPage + 1}
          defaultCurrent={1}
          total={paginationCount}
          onChange={onPageChange}
          showSizeChanger={false}
        />
      )}
    </div>
  );
};

export default NewRequest;
